import ModalItem from './ModalItem';

export default function PayPal({ fields }) {
  return (
    <>
      {fields.map((field) => <ModalItem field={field} key={field.value} />)}
    </>
  );
}
